import LoadingIndicator from './SplashScreen';

export default LoadingIndicator;
